module.exports = __webpack_public_path__ + "static/img/06-中国人民大学附属中学1.34f6f56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/06-中国人民大学附属中学1.png
// module id = kg/b
// module chunks = 0